import React from "react";
import InteractiveHomePage from "../components/InteractiveHomePage";

const Home = () => <InteractiveHomePage locale="en" />;

export default Home;
